const actions = {
  CREATE_ATTENDANCE_BEGIN: "CREATE_ATTENDANCE_BEGIN",
  CREATE_ATTENDANCE_SUCCESS: "CREATE_ATTENDANCE_SUCCESS",
  CREATE_ATTENDANCE_ERR: "CREATE_ATTENDANCE_ERR",

  LIST_ATTENDANCES_BEGIN: "LIST_ATTENDANCES_BEGIN",
  LIST_ATTENDANCES_SUCCESS: "LIST_ATTENDANCES_SUCCESS",
  LIST_ATTENDANCES_ERR: "LIST_ATTENDANCES_ERR",

  GET_ATTENDANCE_DETAILS_BEGIN: "GET_ATTENDANCE_DETAILS_BEGIN",
  GET_ATTENDANCE_DETAILS_SUCCESS: "GET_ATTENDANCE_DETAILS_SUCCESS",
  GET_ATTENDANCE_DETAILS_ERR: "GET_ATTENDANCE_DETAILS_ERR",

  UPDATE_ATTENDANCE_BEGIN: "UPDATE_ATTENDANCE_BEGIN",
  UPDATE_ATTENDANCE_SUCCESS: "UPDATE_ATTENDANCE_SUCCESS",
  UPDATE_ATTENDANCE_ERR: "UPDATE_ATTENDANCE_ERR",

  DELETE_ATTENDANCE_BEGIN: "DELETE_ATTENDANCE_BEGIN",
  DELETE_ATTENDANCE_SUCCESS: "DELETE_ATTENDANCE_SUCCESS",
  DELETE_ATTENDANCE_ERR: "DELETE_ATTENDANCE_ERR",

  createAttendanceBegin: () => {
    return {
      type: actions.CREATE_ATTENDANCE_BEGIN,
    };
  },

  createAttendanceSuccess: (data) => {
    return {
      type: actions.CREATE_ATTENDANCE_SUCCESS,
      data,
    };
  },

  createAttendanceErr: (err) => {
    return {
      type: actions.CREATE_ATTENDANCE_ERR,
      err,
    };
  },

  listAttendancesBegin: () => {
    return {
      type: actions.LIST_ATTENDANCES_BEGIN,
    };
  },

  listAttendancesSuccess: (data) => {
    return {
      type: actions.LIST_ATTENDANCES_SUCCESS,
      data,
    };
  },

  listAttendancesErr: (err) => {
    return {
      type: actions.LIST_ATTENDANCES_ERR,
      err,
    };
  },

  updateAttendanceBegin: () => {
    return {
      type: actions.UPDATE_ATTENDANCE_BEGIN,
    };
  },

  updateAttendanceSuccess: (data) => {
    return {
      type: actions.UPDATE_ATTENDANCE_SUCCESS,
      data,
    };
  },

  updateAttendanceErr: (err) => {
    return {
      type: actions.UPDATE_ATTENDANCE_ERR,
      err,
    };
  },

  deleteAttendanceBegin: () => {
    return {
      type: actions.DELETE_ATTENDANCE_BEGIN,
    };
  },

  deleteAttendanceSuccess: (data) => {
    return {
      type: actions.DELETE_ATTENDANCE_SUCCESS,
      data,
    };
  },

  deleteAttendanceErr: (err) => {
    return {
      type: actions.DELETE_ATTENDANCE_ERR,
      err,
    };
  },

  getAttendanceDetailsBegin: () => {
    return {
      type: actions.GET_ATTENDANCE_DETAILS_BEGIN,
    };
  },

  getAttendanceDetailsSuccess: (data) => {
    return {
      type: actions.GET_ATTENDANCE_DETAILS_SUCCESS,
      data,
    };
  },

  getAttendanceDetailsErr: (err) => {
    return {
      type: actions.GET_ATTENDANCE_DETAILS_ERR,
      err,
    };
  },
};

export default actions;
